var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-spacer',[(_vm.title)?_c('p',{class:`custom__v-spacer ${_vm.classes}`,style:(_vm.styles)},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }